import axios from "axios";
import Vue from "vue";
import { getDeviceNo } from "@/util/device";
import { store } from "@/store/index.js";
import { db } from "@/mixins/playSvgamixin";
import { i18n } from "@/main.js";

import {
  md5RequestParams,
  md5Apis,
  parseCookie,
  decodeResponse,
  decodeResponseData,
} from "@/util/sign";
Vue.prototype.$axios = axios;

let device_no = "";

db.find("device").then((d) => {
  if (d) {
    device_no = d;
    localStorage.setItem("device_no", device_no);
  } else {
    getDeviceNo().then((device) => {
      // 2d4641b6642e61ce34be436a02937e42
      device_no = device ?? (Date.now() + Math.random() * 1000000).toString();
      db.insert("device", device_no).then();
      localStorage.setItem("device_no", device_no);
    });
  }
});

const instance = axios.create({
  baseURL: API_URL || "",
  // baseURL: ENV === "dev" ? "https://test_api.mliveplus.com" : API_URL,
  timeout: 20000,
  // withCredentials: true, //跨域影响，是否带cookie
});

instance.interceptors.request.use(
  async (config) => {
    // if (md5Apis[config.url]) {
    //   config = md5RequestParams(config)
    // }

    // encrypt_on 为1返回加密密文
    config.data.encrypt_on = 1;

    let token = localStorage.getItem("token");
    let id = localStorage.getItem("id");
    if (!device_no) await getDeviceNo();

    config.headers["Authorization"] = `token=${token}; uid=${id}`;
    config.headers["platform"] = "0";
    config.headers["device-info"] = device_no;

    let lang = "";
    const historyLang = localStorage.getItem("lang");
    if (historyLang) {
      lang = historyLang;
    } else {
      lang = window.navigator.language || "en-US";
    }
    config.headers["lang"] = lang;

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
instance.interceptors.response.use(
  async (res) => {
    console.log(res, "ressss");
    if (![9996, 9997, 9998, 9999, 10000].includes(res.data.code)) {
      // showFailToast(i18n.t(`code.${res.data.code}`));
      Vue.prototype.$message.error(i18n.t(`code.${res.data.code}`));
    }
    if (res.data.status === 2) {
      store.commit("changeUserInfo", {
        id: "",
        diamond: 0,
        gold: 0,
      });
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("id");
      if (!store.state.showLogin) {
        store.commit("toggleLogin");
      }

      return Promise.reject(new Error("登陆超时"));
    }

    if (res.data.status === 1) {
      // Vue.prototype.$message.error(res.data.msg);
      return Promise.reject(new Error(res.data.msg));
    }

    if (res.config.url.indexOf("/api/ads/getHomeBannerBg") === -1) {
      res.data.data = await decodeResponseData(res.data.data);
    }
    if (res.config.url !== "/api/maintain") {
      console.log("\n======API result start=====");
      console.log("接口:", res.config.url);
      console.log("入参:", res.config.data);
      console.log("返回:", res.data.data);
      console.log("======API result end=========\n");
    }

    return res;
  },
  (err) => {
    Vue.prototype.$message.warning(i18n.t("pc.overtimeHttp"));
    return Promise.reject(err);
  }
);

export const post = ({ req, data, url }) => {
  if (!data) {
    data = {};
  }
  // if (req && req.headers.cookie) {
  //   const { token, uid } = parseCookie(req.headers.cookie);
  //   if (token && uid) {
  //     data.token = decodeURIComponent(token);
  //     data.uid = parseInt(uid);
  //   }
  // }

  return instance.post(url, data);
};

export const get = ({ req, data, url }) => {
  if (!data) {
    data = {};
  }
  if (req && req.headers.cookie) {
    const { token, uid } = parseCookie(req.headers.cookie);
    if (token && uid) {
      data.token = decodeURIComponent(token);
      data.uid = parseInt(uid);
    }
  }
  return instance.get(url, {
    params: data,
    data,
  });
};
